module.exports = __webpack_public_path__ + "img/icon-drop-stroke.261bc129.svg";